import AboriginalSonglinePreview from '../assets/images/aboriginal-songline-banner.png';
import NakasendoCoverPreview from '../assets/images/Nakasendo_cut3_landscape-Cover.jpg';
import NakasendoDetailPreview from '../assets/images/Nakasendo_preview_cut2.png';
import SakuraPreview from '../assets/images/sakuras_maps_example.png';
import WinterPreview from '../assets/images/yukiguni_map_example.png';

const CURATED_PREVIEW_SAMPLES = [
  { id: 'nakasendo-cover', label: 'Japanese Landscape', src: NakasendoCoverPreview },
  { id: 'nakasendo-detail', label: 'Japanese Detail', src: NakasendoDetailPreview },
  { id: 'sakura', label: 'Sakura Bloom', src: SakuraPreview },
  { id: 'winter', label: 'Snow Field', src: WinterPreview },
  { id: 'aboriginal-songline', label: 'Songline Earth', src: AboriginalSonglinePreview },
];

const SAMPLE_MATCHERS = [
  { pattern: /(aboriginal|songline)/i, sampleId: 'aboriginal-songline' },
  { pattern: /sakura/i, sampleId: 'sakura' },
  { pattern: /(winter|yuki|wonderland)/i, sampleId: 'winter' },
  { pattern: /(japanese|nakasendo)/i, sampleId: 'nakasendo-cover' },
];

const DEFAULT_PREVIEW_SAMPLE_ID = 'nakasendo-cover';

export function getRecommendedLogoPreviewSampleId(styleName) {
  const normalizedStyleName = (styleName || '').trim();
  if (!normalizedStyleName) {
    return DEFAULT_PREVIEW_SAMPLE_ID;
  }

  const match = SAMPLE_MATCHERS.find(({ pattern }) => pattern.test(normalizedStyleName));
  return match?.sampleId || DEFAULT_PREVIEW_SAMPLE_ID;
}

export function getLogoPreviewOptions(styleName, currentExampleSrc) {
  const recommendedOptionId = getRecommendedLogoPreviewSampleId(styleName);
  const recommendedSample = CURATED_PREVIEW_SAMPLES.find((sample) => sample.id === recommendedOptionId);
  const remainingSamples = CURATED_PREVIEW_SAMPLES.filter((sample) => sample.id !== recommendedOptionId);
  const orderedCuratedSamples = [recommendedSample, ...remainingSamples].filter(Boolean);
  const options = orderedCuratedSamples.map((sample, index) => ({
    ...sample,
    label: index === 0 ? `${sample.label} (Recommended Alt)` : sample.label,
  }));

  if (currentExampleSrc) {
    return {
      options: [
        {
          id: 'create-page-example',
          label: 'Create Page Example (Default)',
          src: currentExampleSrc,
        },
        ...options,
      ],
      recommendedOptionId: 'create-page-example',
    };
  }

  return {
    options,
    recommendedOptionId,
  };
}
